import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectTechnology, technologyListUpdateSelected } from "../../app/actions/technologyActions";
import { registerPanelViewInterest } from "../../app/helpers/intentTrackingHelper";
import ReadMoreReadLess from "../generic-read-more/ReadMoreReadLess";
import L5ModalTechnology from "./L5ModalTechnology";
import { debugLogPages } from "../../app/helpers/debugHelper";
import { useTranslation } from "react-i18next";
import SemanticSimilarityBadge from "./SemanticSimilarityBadge";

const L4CardTechnology = ({ data, moduleSelected }) => {

  debugLogPages(':: L4CardTechnology');

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { comparisonTechnologyCheckEnabled } = useSelector((state) => state.configuration);
  const [checked] = useState(false);
  const [popupInformationTechIsOpen, setPopupInformationTechIsOpen] = useState(false);

  const isChecked = data.isSelected;

   const handleToggle = () => {
    dispatch(technologyListUpdateSelected(data.id));
  };


  const closeModal = () => {
    setPopupInformationTechIsOpen(false);
  }

  const handleViewTechnology = (e) => {
    e.preventDefault();
    dispatch(selectTechnology(data));
    registerPanelViewInterest(dispatch, 'technology', data);

    navigate(`/end-user-search/preview-technology`);

  };

  const PreviewImageShow = () => {
  // Imagen por defecto
  //const defaultImg = "/Modulos/TecBC.png";
  const defaultImg = '/images/logo_teccc_no_disponible.png'

  const handleImgError = (e) => {
    // Si la imagen falla, reemplazamos el src por la de defecto
    e.target.src = defaultImg;
    // Opcional: puedes quitar el atributo onError para evitar bucles si la de defecto también falla
    e.target.onerror = null; 
  };

  if (data.ModuleFile_To_Technology && data.ModuleFile_To_Technology.length > 0) {
    return (
      <img 
        src={data.ModuleFile_To_Technology[0].url} 
        alt="file" 
        onError={handleImgError} // <-- El truco está aquí
      />
    );
  } else {
    return (
      <div>
        <img src={defaultImg} width="300px" alt="technology" />
      </div>
    );
  }
};

  const handlePopupSwall = (e) => {
    e.preventDefault();
    registerPanelViewInterest(dispatch, 'technology', data);
    setPopupInformationTechIsOpen(true);
  };

  return (
    <li className="cards__item">
      <div className="card"
      >
        {comparisonTechnologyCheckEnabled === "true" && <div>
          <label>
            <input
              type="checkbox"
              checked={isChecked} 
              onChange={handleToggle}
            />
            <div className="espacioComparar">{checked ? `${t('general.card-selected')}` : `${t('general.card-select')}`}</div>
          </label>
        </div>}
        <div className="card__image" onClick={handlePopupSwall}>
          <PreviewImageShow />
        </div>
        <div className="card__content">
          <SemanticSimilarityBadge data={data} moduleKey="technology" />
          <div className="card__title">
            <ReadMoreReadLess
              className='read-more-less'
              buttonClassName='btn-read-more-less'
              expandLabel="Leer más" 
              collapseLabel="Leer menos" 
              limit={100}
            >
              {data && data.name}
            </ReadMoreReadLess>
          </div>
          <br />
          <div className="card__text">
            <ReadMoreReadLess
              className='read-more-less'
              buttonClassName='btn-read-more-less'
              expandLabel="Leer más" 
              collapseLabel="Leer menos" 
              limit={100}
            >
              {data && data.purpose}
            </ReadMoreReadLess>
          </div>

          <button className="btn btn--block button-color-view" onClick={handleViewTechnology}>
            {t("buttons.view")}
          </button>
        </div>
      </div>

      <L5ModalTechnology
        modalIsOpen={popupInformationTechIsOpen}
        closeModal={closeModal}
        data={data}
        moduleSelected={moduleSelected}
      />

    </li>
  );
};

export default L4CardTechnology;
